export default __webpack_public_path__ + "static/media/Key_light.fea3aab8.svg";